var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 163,
    viewBox: "0 0 256 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    clipPath: "url(#clip0_1129_482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.1,
    d: "M174.114 47.438C178.513 53.6507 182.251 60.3607 188.346 65.3653C198.748 73.9127 214.555 76.1054 223.26 86.4496C232.596 97.5349 228.492 113.249 218.486 122.548C211.832 128.73 202.872 132.689 193.567 135.054C173.413 140.191 38.978 134.486 32.304 131.542C23.3646 127.603 19.3622 120.051 20.0124 111.523C21.0688 97.5552 32.9744 86.1755 46.0583 78.4402C59.1423 70.715 74.0242 65.3653 86.2345 56.5945C93.2133 51.5798 99.1661 45.5499 105.83 40.2103C111.376 35.764 117.563 31.805 124.623 29.4194C142.816 23.2677 164.393 33.6728 174.114 47.4279V47.438Z",
    fill: "#6797C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M171.534 146.81L170.315 150.241L167.755 148.394V110.793H171.534V146.81Z",
    fill: "#6797C6",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M76.4107 109.695H72.6318V144.697H76.4107V109.695Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M109.933 85.8086H39.1096C38.5486 85.8086 38.0938 86.2631 38.0938 86.8237V108.487C38.0938 109.047 38.5486 109.502 39.1096 109.502H109.933C110.494 109.502 110.949 109.047 110.949 108.487V86.8237C110.949 86.2631 110.494 85.8086 109.933 85.8086Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M90.1758 95.1574C93.5382 94.9341 96.5755 96.9745 99.3183 98.9337",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M86.0205 96.3975C86.3151 96.2655 86.6097 96.1335 86.9043 96.0117",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M62.6465 97.0882C64.8915 95.7888 67.045 94.2357 69.5237 94.6011C72.429 95.0275 74.3794 97.9714 77.2135 98.7226C79.4179 99.3113 81.734 98.4688 83.786 97.4841",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.3184 94.6289C51.604 98.1413 56.4495 99.7147 60.3605 98.2225",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M51.2587 86.1445H43.1016V128.8H51.2587V86.1445Z",
    fill: "#6797C6",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.4373 91.5146L51.2593 86.1445V91.8191L43.2646 97.2602L43.4373 91.5146Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M43.4373 101.96L51.2593 96.5898V102.254L43.2646 107.706L43.4373 101.96Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M43.4373 113.097L51.2593 107.727V113.391L43.2646 118.842L43.4373 113.097Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M43.4373 123.339L51.2593 117.969V123.633L43.2646 129.084L43.4373 123.339Z",
    fill: "#121212"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6831 162.268C45.174 160.075 45.042 156.066 47.3987 153.741C49.7554 151.416 54.2048 151.162 56.8663 153.193C56.1653 151 56.7647 148.371 58.7659 146.96C60.7671 145.549 64.1803 145.904 65.3688 147.924C65.4805 144.828 66.3541 141.661 68.4671 139.204C70.58 136.758 74.0846 135.154 77.4978 135.631C80.8094 136.098 83.5624 138.473 84.7306 141.305C85.8988 144.138 85.6245 147.325 84.5376 150.178C86.5692 148.98 89.4034 149.224 91.4046 150.462C93.4058 151.711 94.6146 153.802 95.0311 155.964C95.4476 158.116 95.1428 160.339 94.5943 162.471",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6831 162.268C45.174 160.075 45.042 156.066 47.3987 153.741C49.7554 151.416 54.2048 151.162 56.8663 153.193C56.1653 151 56.7647 148.371 58.7659 146.96C60.7671 145.549 64.1803 145.904 65.3688 147.924C65.4805 144.828 66.3541 141.661 68.4671 139.204C70.58 136.758 74.0846 135.154 77.4978 135.631C80.8094 136.098 83.5624 138.473 84.7306 141.305C85.8988 144.138 85.6245 147.325 84.5376 150.178C86.5692 148.98 89.4034 149.224 91.4046 150.462C93.4058 151.711 94.6146 153.802 95.0311 155.964C95.4476 158.116 95.1428 160.339 94.5943 162.471",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M94.574 162.491L90.4396 162.471C90.4192 161.851 90.3684 161.232 90.2465 160.613C89.8199 158.461 88.6009 156.37 86.62 155.101C84.6188 153.862 81.7745 153.619 79.7428 154.817C80.8399 151.974 81.104 148.776 79.9358 145.934C78.7676 143.122 76.0147 140.737 72.7031 140.28C70.7426 139.996 68.7617 140.402 67.0449 141.254C67.4513 140.534 67.9084 139.843 68.4569 139.204C70.58 136.767 74.0643 135.174 77.4877 135.651C80.8095 136.108 83.5522 138.493 84.7204 141.336C85.8886 144.147 85.6245 147.345 84.5274 150.218C86.5591 149 89.4034 149.243 91.4046 150.502C93.3855 151.741 94.6045 153.842 95.0311 155.994C95.4375 158.166 95.1225 160.39 94.574 162.511V162.491Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M47.6831 162.268C45.174 160.075 45.042 156.066 47.3987 153.741C49.7554 151.416 54.2048 151.162 56.8663 153.193C56.1653 151 56.7647 148.371 58.7659 146.96C60.7671 145.549 64.1803 145.904 65.3688 147.924C65.4805 144.828 66.3541 141.661 68.4671 139.204C70.58 136.758 74.0846 135.154 77.4978 135.631C80.8094 136.098 83.5624 138.473 84.7306 141.305C85.8988 144.138 85.6245 147.325 84.5376 150.178C86.5692 148.98 89.4034 149.224 91.4046 150.462C93.4058 151.711 94.6146 153.802 95.0311 155.964C95.4476 158.116 95.1428 160.339 94.5943 162.471",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M185.146 162.605H255.614",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M179.822 162.605H181.762",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M36.3262 162.605H176.481",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M2.46875 162.605H30.3635",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M156.438 162.615L158.419 153.469",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.419 153.469C158.876 150.789 161.152 148.526 163.833 148.069C166.515 147.612 169.41 149.013 170.721 151.388C170.771 147.318 172.722 143.227 176.115 140.963C179.497 138.699 184.282 138.527 187.604 140.872C190.936 143.216 192.348 148.079 190.468 151.683C193.343 150.668 196.787 151.469 198.9 153.662C201.013 155.855 201.714 159.316 200.596 162.149",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.419 153.469C158.876 150.789 161.152 148.526 163.833 148.069C166.515 147.612 169.41 149.013 170.721 151.388C170.771 147.318 172.722 143.227 176.115 140.963C179.497 138.699 184.282 138.527 187.604 140.872C190.936 143.216 192.348 148.079 190.468 151.683C193.343 150.668 196.787 151.469 198.9 153.662C201.013 155.855 201.714 159.316 200.596 162.149",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M221.726 43.8034C221.726 45.3159 220.497 46.5442 218.983 46.5442C217.469 46.5442 216.24 45.3159 216.24 43.8034C216.24 42.2908 217.469 41.0625 218.983 41.0625C220.497 41.0625 221.726 42.2908 221.726 43.8034Z",
    stroke: "#6797C6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M232.321 135.073C232.321 136.585 231.092 137.814 229.579 137.814C228.065 137.814 226.836 136.585 226.836 135.073C226.836 133.56 228.065 132.332 229.579 132.332C231.092 132.332 232.321 133.56 232.321 135.073Z",
    stroke: "#6797C6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M211.384 109.616C211.384 111.443 209.901 112.915 208.083 112.915C206.264 112.915 204.781 111.433 204.781 109.616C204.781 107.799 206.264 106.316 208.083 106.316C209.901 106.316 211.384 107.799 211.384 109.616Z",
    stroke: "#C2C2C2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M5.99331 125.522C5.99331 127.035 4.76415 128.263 3.25056 128.263C1.73697 128.263 0.507812 127.035 0.507812 125.522C0.507812 124.01 1.73697 122.781 3.25056 122.781C4.76415 122.781 5.99331 124.01 5.99331 125.522Z",
    stroke: "#6797C6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M18.5792 39.7643C18.5792 41.2768 17.3501 42.5052 15.8365 42.5052C14.3229 42.5052 13.0938 41.2768 13.0938 39.7643C13.0938 38.2517 14.3229 37.0234 15.8365 37.0234C17.3501 37.0234 18.5792 38.2517 18.5792 39.7643Z",
    stroke: "#6797C6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M198.87 46.2296C197.793 46.2296 196.838 46.656 196.097 47.3767C195.67 44.8186 193.588 42.9102 191.078 42.9102C188.569 42.9102 186.467 44.8694 186.091 47.4478C185.258 46.8793 184.252 46.5443 183.175 46.5443C180.646 46.5443 178.523 48.4223 177.954 50.9399C177.903 51.1632 178.086 51.3865 178.32 51.3865H202.964C202.964 51.3865 202.974 51.3764 202.984 51.3662C203.39 48.6254 201.369 46.2296 198.86 46.2296H198.87Z",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M65.7341 16.9953C64.6573 16.9953 63.7024 17.4216 62.9609 18.1424C62.5342 15.5842 60.4518 13.6758 57.9427 13.6758C55.4336 13.6758 53.3308 15.635 52.9549 18.2134C52.1219 17.645 51.1163 17.31 50.0395 17.31C47.5101 17.31 45.387 19.188 44.8181 21.7055C44.7673 21.9288 44.9502 22.1521 45.1838 22.1521H69.8279C69.8279 22.1521 69.8381 22.142 69.8482 22.1318C70.2546 19.391 68.233 16.9953 65.7239 16.9953H65.7341Z",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M24.9392 72.6828C23.8624 72.6828 22.9075 73.1091 22.166 73.8299C21.7393 71.2717 19.6568 69.3633 17.1477 69.3633C14.6386 69.3633 12.5359 71.3225 12.16 73.9009C11.327 73.3325 10.3213 72.9975 9.24456 72.9975C6.71514 72.9975 4.59205 74.8755 4.02318 77.393C3.97239 77.6163 4.15524 77.8396 4.38888 77.8396H29.033C29.033 77.8396 29.0431 77.8295 29.0533 77.8193C29.4596 75.0785 27.4381 72.6828 24.929 72.6828H24.9392Z",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M211.202 66.8789H226.125",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M233.489 72.8359H251.795",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M224.307 72.8359H228.807",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M30.3223 52.7344H45.2448",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M52.6094 58.7031H70.9147",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M43.4268 58.7031H47.9371",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M121.077 75.8906H117.298V134.961H121.077V75.8906Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M90.9168 162.595C89.4134 159.732 89.261 155.408 89.84 152.393C90.4191 149.378 92.1155 146.444 94.909 144.698C97.7026 142.952 101.674 142.617 104.519 144.292C102.995 140.303 102.619 135.836 104.255 131.877C105.89 127.918 109.74 124.588 114.372 123.939C119.137 123.269 124.033 125.512 126.999 128.933C129.955 132.354 131.184 136.79 131.337 141.125C133.003 138.303 137.767 137.805 140.571 139.775C143.374 141.744 144.197 145.419 143.222 148.485C146.95 145.632 153.167 145.998 156.458 149.246C159.75 152.494 159.963 159.519 156.458 162.595H90.9168Z",
    fill: "#6797C6",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M156.529 162.564C156.915 159.58 156.052 156.291 154.071 154.332C150.8 151.083 144.563 150.728 140.845 153.57C141.82 150.495 140.987 146.82 138.194 144.861C135.4 142.881 130.626 143.378 128.95 146.201C128.807 141.876 127.588 137.44 124.622 134.009C121.656 130.598 116.77 128.354 111.985 129.024C108.592 129.502 105.606 131.41 103.604 133.988C103.767 133.268 103.991 132.577 104.275 131.887C105.9 127.928 109.74 124.609 114.372 123.939C119.147 123.269 124.043 125.512 127.009 128.953C129.976 132.364 131.184 136.8 131.337 141.145C133.013 138.303 137.787 137.826 140.581 139.785C143.374 141.764 144.207 145.439 143.232 148.495C146.96 145.652 153.187 146.008 156.458 149.256C159.729 152.504 159.973 159.468 156.529 162.575V162.564Z",
    fill: "#4A67AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M117.036 1.27743L81.2428 37.0458C80.0527 38.2351 80.0527 40.1633 81.2428 41.3526L117.036 77.121C118.226 78.3103 120.155 78.3103 121.346 77.121L157.139 41.3526C158.329 40.1633 158.329 38.2351 157.139 37.0458L121.346 1.27743C120.155 0.0881301 118.226 0.0881322 117.036 1.27743Z",
    fill: "#6797C6",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M154.234 44.2593L124.267 74.2057C121.666 76.8045 119.137 80.4996 114.738 74.7031C114.952 74.561 115.124 74.3885 115.307 74.2057L145.274 44.2593C148.068 41.4677 148.068 36.93 145.274 34.1384L115.307 4.16152C115.114 3.96865 114.952 3.80622 114.738 3.63365C118.924 -2.23382 121.666 1.55263 124.267 4.16152L154.234 34.1384C157.027 36.93 160.441 38.8385 154.234 44.2593Z",
    fill: "#4A67AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M146.778 104.246L165.683 72.4314C167.288 69.7312 171.199 69.7312 172.804 72.4314L191.708 104.246C193.344 107.007 191.363 110.499 188.153 110.499H150.354C147.144 110.499 145.153 107.007 146.798 104.246H146.778Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M169.248 98.0835C168.445 98.0835 167.785 97.4744 167.714 96.6724L166.566 83.3742C166.485 82.4707 167.196 81.6992 168.1 81.6992H170.406C171.31 81.6992 172.021 82.4707 171.94 83.3742L170.792 96.6724C170.721 97.4642 170.06 98.0835 169.258 98.0835H169.248Z",
    fill: "#6797C6",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M169.247 105.271C168.13 105.271 167.226 104.367 167.226 103.251C167.226 102.134 168.13 101.23 169.247 101.23C170.365 101.23 171.269 102.134 171.269 103.251C171.269 104.367 170.365 105.271 169.247 105.271Z",
    fill: "#6797C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M169.247 101.597C170.151 101.597 170.893 102.328 170.893 103.242C170.893 104.155 170.162 104.886 169.247 104.886C168.333 104.886 167.602 104.155 167.602 103.242C167.602 102.328 168.333 101.597 169.247 101.597ZM169.247 100.836C167.917 100.836 166.84 101.912 166.84 103.242C166.84 104.572 167.917 105.648 169.247 105.648C170.578 105.648 171.655 104.572 171.655 103.242C171.655 101.912 170.578 100.836 169.247 100.836Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M152.04 102.59L155.138 97.1484",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M156.185 95.2831L156.743 94.207",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M90.9168 162.595C89.4134 159.732 89.261 155.408 89.84 152.393C90.4191 149.378 92.1155 146.444 94.909 144.698C97.7026 142.952 101.674 142.617 104.519 144.292C102.995 140.303 102.619 135.836 104.255 131.877C105.89 127.918 109.74 124.588 114.372 123.939C119.137 123.269 124.033 125.512 126.999 128.933C129.955 132.354 131.184 136.79 131.337 141.125C133.003 138.303 137.767 137.805 140.571 139.775C143.374 141.744 144.197 145.419 143.222 148.485C146.95 145.632 153.167 145.998 156.458 149.246C159.75 152.494 159.963 159.519 156.458 162.595H90.9168Z",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M100.1 149.376C100.273 148.899 100.354 148.229 99.7445 147.752C99.3788 147.468 98.9014 147.387 98.556 147.458C98.2106 147.529 97.9668 147.732 97.7433 147.935C96.0164 149.519 94.8279 151.549 94.2692 153.853C94.1473 154.371 94.0558 154.929 94.32 155.538C94.6247 156.239 95.539 157.01 96.1688 156.675C96.9002 156.29 97.3065 155.071 97.7027 154.422C98.6677 152.828 99.4702 151.143 100.11 149.366L100.1 149.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M96.453 31.5186C96.6968 31.072 96.8898 30.4223 96.3616 29.8538C96.0467 29.5188 95.5896 29.3564 95.234 29.3767C94.8785 29.397 94.6042 29.5493 94.3503 29.7218C92.3897 31.0009 90.8863 32.8078 89.9517 34.9904C89.7384 35.4776 89.5657 36.0157 89.7282 36.6654C89.9212 37.4064 90.6831 38.32 91.3637 38.0967C92.1561 37.8328 92.7452 36.706 93.243 36.1273C94.4518 34.7163 95.5286 33.1834 96.4429 31.5288L96.453 31.5186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M135.4 36.6086C135.4 28.6398 128.147 22.1836 119.187 22.1836C110.228 22.1836 102.975 28.6398 102.975 36.6086C102.975 42.2934 106.672 47.1863 112.036 49.5414C112.625 50.2216 113.113 50.9829 113.458 51.8153C113.763 52.5564 113.966 53.3482 114.403 54.0283C114.84 54.7085 115.581 55.2668 116.384 55.1754C117.704 55.0333 118.446 53.2873 119.766 53.2264C120.579 53.1858 121.249 53.805 121.869 54.343C122.479 54.881 123.281 55.4089 124.053 55.145C124.785 54.9013 125.12 54.0892 125.374 53.3583C125.821 52.0387 126.247 50.719 126.674 49.3892C131.845 46.9833 135.39 42.1614 135.39 36.6086H135.4Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M125.292 45.6823C125.292 47.1644 124.307 48.3724 123.088 48.3724C121.869 48.3724 120.884 47.1644 120.884 45.6823C120.884 44.2002 121.869 42.9922 123.088 42.9922C124.307 42.9922 125.292 44.2002 125.292 45.6823Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M118.222 45.6823C118.222 47.1644 117.237 48.3724 116.018 48.3724C114.799 48.3724 113.813 47.1644 113.813 45.6823C113.813 44.2002 114.799 42.9922 116.018 42.9922C117.237 42.9922 118.222 44.2002 118.222 45.6823Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M117.036 1.27743L81.2428 37.0458C80.0527 38.2351 80.0527 40.1633 81.2428 41.3526L117.036 77.121C118.226 78.3103 120.155 78.3103 121.346 77.121L157.139 41.3526C158.329 40.1633 158.329 38.2351 157.139 37.0458L121.346 1.27743C120.155 0.0881301 118.226 0.0881322 117.036 1.27743Z",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M89.1699 44.0859L98.5257 53.1308",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M100.06 54.8281L102.305 57.1325",
    stroke: "#121212",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1129_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 163,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/NoDataFound.260447f7100f0498866b01ca38b622f9.svg";
export { ForwardRef as ReactComponent };